// HELPERS
import { checkUser } from 'helpers/checkUser';

// MAIN COMPONENT
const Feature = checkUser(({
  children
}) => children)

// EXPORT
export default Feature